// Trilingual dictionary: German (default), English, Spanish.
export const translations = {
  de: {
    brand: {
      name: "Christian's Multiservice",
      short: "Multiservice",
    },
    nav: {
      services: "Leistungen",
      area: "Einsatzgebiet",
      about: "Über mich",
      contact: "Kontakt",
      cta: "Anfrage senden",
    },
    hero: {
      eyebrow: "Multiservice · Costa Blanca",
      title_line1: "Ihr Ansprechpartner",
      title_line2: "vor Ort an der südlichen Costa Blanca.",
      description:
        "Ich kümmere mich um Ihre Immobilie oder Ferienwohnung, wenn Sie nicht vor Ort sind — Kontrollgänge, Schlüsselservice, Gästebetreuung und kleine Handwerksarbeiten. Zuverlässig, ehrlich, deutschsprachig.",
      primary_cta: "Anfrage senden",
      secondary_cta: "Leistungen ansehen",
      badge_1: "Meister · Heizungs- & Lüftungsbau",
      badge_2: "Erfahrung Wohnungsverwaltung",
      badge_3: "Selbst Eigentümer in Torrevieja",
    },
    services: {
      eyebrow: "Was wir anbieten",
      title: "Multiservice für Ihr Zuhause an der Costa Blanca.",
      subtitle:
        "Von der regelmäßigen Kontrolle bis zur Gästebetreuung — ich bin da, wenn Sie es nicht sein können.",
      items: [
        {
          title: "Kontrollgänge",
          desc: "Regelmäßige Sichtprüfung Ihres Objekts, Mängel feststellen und dokumentieren.",
        },
        {
          title: "Lüften & Wasser laufen lassen",
          desc: "Frische Luft, keine trockenen Siphons — für ein gesundes Raumklima auch bei Abwesenheit.",
        },
        {
          title: "Sturm- & Schadenscheck",
          desc: "Sichtung nach Sturm oder Schäden, Kontrolle von Wasserständen und Schädlingsbefall.",
        },
        {
          title: "Hausbegehung",
          desc: "Vollständige Begehung von Haus oder Wohnung mit Fotoprotokoll auf Wunsch.",
        },
        {
          title: "Schlüsselservice",
          desc: "Sichere Aufbewahrung, Übergabe an Mieter und Einlass von Handwerkern oder Dienstleistern.",
        },
        {
          title: "Postservice & Gästebetreuung",
          desc: "Post nachschicken, Gäste empfangen, Einweisung in die Örtlichkeiten für Mieter und Kunden.",
        },
        {
          title: "Kleine Handwerksarbeiten",
          desc: "Tropfende Wasserhähne, Möbelaufbau, klemmende oder quietschende Türen und Schlösser.",
        },
        {
          title: "Reinigung & Bettwechsel",
          desc: "Auf Wunsch auch Endreinigung und frisch bezogene Betten für den nächsten Aufenthalt.",
        },
      ],
    },
    area: {
      eyebrow: "Einsatzgebiet",
      title: "Ihr Multiservice in der Region.",
      subtitle:
        "Ich bin in folgenden Orten an der südlichen Costa Blanca für Sie im Einsatz:",
      cities: [
        "Torrevieja",
        "Punta Prima",
        "Orihuela Costa",
        "Los Altos",
        "San Miguel de Salinas",
        "Guardamar del Segura",
        "La Marina",
      ],
      note: "Außerhalb des Gebietes gerne auf Anfrage!",
    },
    about: {
      eyebrow: "Über mich",
      title: "Hallo, ich bin Christian.",
      name: "Christian Reuter",
      origin: "aus Hamburg",
      p1: "Ich möchte mich hier kurz vorstellen. Ich bin ausgebildeter Heizungs- und Lüftungsbauer und habe später auch darin meinen Meisterabschluss gemacht.",
      p2: "Die letzten Jahre habe ich in einer Immobilienfirma gearbeitet, wobei ich unter anderem für die Wohnungsverwaltung zuständig war.",
      p3: "Da wir selbst vor 5 Jahren Eigentum in Torrevieja erworben haben, weiß ich, wie wichtig es ist, jemanden vor Ort zu wissen, der sich bei Abwesenheit oder Vermietung schnell und zuverlässig kümmert.",
      pill_1: "Meister Heizungs- & Lüftungsbau",
      pill_2: "Erfahrung Wohnungsverwaltung",
      pill_3: "Selbst Eigentümer in Torrevieja",
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Erzählen Sie mir von Ihrem Anliegen.",
      subtitle:
        "Beschreiben Sie kurz, worum es geht — Sie bekommen zeitnah eine ehrliche Einschätzung.",
      name: "Name",
      name_ph: "Vor- und Nachname",
      email: "E-Mail",
      email_ph: "ihre@email.com",
      service: "Gewünschte Leistung",
      service_ph: "Leistung wählen",
      location: "Ungefährer Ort",
      location_ph: "Bitte wählen",
      message: "Kurze Beschreibung (optional)",
      message_ph: "Was soll gemacht werden?",
      submit: "Anfrage senden",
      submitting: "Wird gesendet…",
      success_title: "Anfrage gesendet",
      success_desc: "Ich melde mich in Kürze bei Ihnen.",
      error_title: "Etwas ist schiefgelaufen",
      error_desc: "Bitte versuchen Sie es später erneut.",
      required: "Pflichtfeld",
      invalid_email: "Bitte geben Sie eine gültige E-Mail an.",
      other_location: "Anderer Ort (auf Anfrage)",
    },
    footer: {
      tagline: "Multiservice an der südlichen Costa Blanca — Kontrollgänge, Schlüsselservice und mehr.",
      areas: "Einsatzgebiet",
      contact: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
    },
  },
  en: {
    brand: {
      name: "Christian's Multiservice",
      short: "Multiservice",
    },
    nav: {
      services: "Services",
      area: "Service area",
      about: "About",
      contact: "Contact",
      cta: "Send request",
    },
    hero: {
      eyebrow: "Multiservice · Costa Blanca",
      title_line1: "Your on-site contact",
      title_line2: "on the southern Costa Blanca.",
      description:
        "I look after your home or holiday flat when you're away — property checks, key service, guest handling and small handyman jobs. Reliable, honest, German-speaking.",
      primary_cta: "Send request",
      secondary_cta: "See services",
      badge_1: "Master · Heating & Ventilation",
      badge_2: "Property management background",
      badge_3: "Own property in Torrevieja",
    },
    services: {
      eyebrow: "What we offer",
      title: "Multiservice for your home on the Costa Blanca.",
      subtitle:
        "From regular property checks to guest handling — I'm there when you can't be.",
      items: [
        {
          title: "Property checks",
          desc: "Regular visual inspections of your property, identifying and documenting any issues.",
        },
        {
          title: "Airing & water flushing",
          desc: "Fresh air and no dry siphons — for a healthy indoor climate even during absence.",
        },
        {
          title: "Storm & damage check",
          desc: "Inspection after storms or damage, checking water levels and pest signs.",
        },
        {
          title: "Full walkthrough",
          desc: "Complete walkthrough of the house or flat, with a photo report on request.",
        },
        {
          title: "Key service",
          desc: "Secure storage, handover to tenants, and access for tradespeople or service providers.",
        },
        {
          title: "Mail & guest service",
          desc: "Forwarding mail, welcoming guests, orientation for tenants and customers.",
        },
        {
          title: "Small handyman jobs",
          desc: "Dripping taps, furniture assembly, sticking or squeaking doors and locks.",
        },
        {
          title: "Cleaning & bed change",
          desc: "On request also final cleaning and freshly made beds for the next stay.",
        },
      ],
    },
    area: {
      eyebrow: "Service area",
      title: "Your multiservice in the region.",
      subtitle:
        "I'm available in the following towns along the southern Costa Blanca:",
      cities: [
        "Torrevieja",
        "Punta Prima",
        "Orihuela Costa",
        "Los Altos",
        "San Miguel de Salinas",
        "Guardamar del Segura",
        "La Marina",
      ],
      note: "Outside this area happily on request!",
    },
    about: {
      eyebrow: "About me",
      title: "Hi, I'm Christian.",
      name: "Christian Reuter",
      origin: "from Hamburg",
      p1: "A short introduction. I'm a trained heating and ventilation engineer and later also earned my master craftsman's certificate in this field.",
      p2: "In recent years I worked at a real estate company where, among other things, I was responsible for property management.",
      p3: "As we bought our own property in Torrevieja five years ago, I know first-hand how important it is to have someone reliable on-site who takes care of things quickly during absence or rental.",
      pill_1: "Master craftsman",
      pill_2: "Property management experience",
      pill_3: "Property owner in Torrevieja",
    },
    contact: {
      eyebrow: "Contact",
      title: "Tell me about your request.",
      subtitle:
        "Briefly describe what you need — you'll get an honest assessment shortly.",
      name: "Name",
      name_ph: "First and last name",
      email: "Email",
      email_ph: "your@email.com",
      service: "Service needed",
      service_ph: "Choose a service",
      location: "Approximate location",
      location_ph: "Please select",
      message: "Short description (optional)",
      message_ph: "What should be done?",
      submit: "Send request",
      submitting: "Sending…",
      success_title: "Request sent",
      success_desc: "I'll get back to you shortly.",
      error_title: "Something went wrong",
      error_desc: "Please try again later.",
      required: "Required",
      invalid_email: "Please enter a valid email.",
      other_location: "Other (on request)",
    },
    footer: {
      tagline: "Multiservice along the southern Costa Blanca — property checks, key service and more.",
      areas: "Service area",
      contact: "Contact",
      rights: "All rights reserved.",
    },
  },
  es: {
    brand: {
      name: "Christian's Multiservice",
      short: "Multiservice",
    },
    nav: {
      services: "Servicios",
      area: "Zona de servicio",
      about: "Sobre mí",
      contact: "Contacto",
      cta: "Enviar consulta",
    },
    hero: {
      eyebrow: "Multiservicio · Costa Blanca",
      title_line1: "Tu persona de confianza",
      title_line2: "en la Costa Blanca sur.",
      description:
        "Cuido tu propiedad o apartamento vacacional cuando no estás — revisiones, servicio de llaves, atención a huéspedes y pequeños trabajos. Fiable, honesto, en alemán, inglés y español.",
      primary_cta: "Enviar consulta",
      secondary_cta: "Ver servicios",
      badge_1: "Maestro · Calefacción y Ventilación",
      badge_2: "Experiencia en gestión inmobiliaria",
      badge_3: "Propietario en Torrevieja",
    },
    services: {
      eyebrow: "Qué ofrecemos",
      title: "Multiservicio para tu casa en la Costa Blanca.",
      subtitle:
        "Desde revisiones periódicas hasta atención a huéspedes — estoy cuando tú no puedes.",
      items: [
        {
          title: "Revisiones periódicas",
          desc: "Inspecciones visuales regulares de la propiedad, detectando y documentando cualquier problema.",
        },
        {
          title: "Ventilación y agua",
          desc: "Aire fresco y sifones que no se secan — para un ambiente sano incluso durante tu ausencia.",
        },
        {
          title: "Revisión tras tormentas",
          desc: "Inspección tras tormentas o daños, control de niveles de agua y plagas.",
        },
        {
          title: "Recorrido completo",
          desc: "Recorrido completo por la casa o apartamento, con reporte fotográfico bajo petición.",
        },
        {
          title: "Servicio de llaves",
          desc: "Custodia segura, entrega a inquilinos y acceso para gremios o proveedores.",
        },
        {
          title: "Correo y huéspedes",
          desc: "Reenvío de correo, recepción de huéspedes, orientación para inquilinos y clientes.",
        },
        {
          title: "Pequeños arreglos",
          desc: "Grifos que gotean, montaje de muebles, puertas o cerraduras que se atascan.",
        },
        {
          title: "Limpieza y cambio de cama",
          desc: "Bajo petición también limpieza final y camas recién hechas para la próxima estancia.",
        },
      ],
    },
    area: {
      eyebrow: "Zona de servicio",
      title: "Tu multiservicio en la zona.",
      subtitle:
        "Estoy disponible en las siguientes localidades de la Costa Blanca sur:",
      cities: [
        "Torrevieja",
        "Punta Prima",
        "Orihuela Costa",
        "Los Altos",
        "San Miguel de Salinas",
        "Guardamar del Segura",
        "La Marina",
      ],
      note: "¡Fuera de la zona con mucho gusto bajo petición!",
    },
    about: {
      eyebrow: "Sobre mí",
      title: "Hola, soy Christian.",
      name: "Christian Reuter",
      origin: "de Hamburgo",
      p1: "Una breve presentación. Soy instalador de calefacción y ventilación de formación, y más tarde obtuve también el título de maestro en este oficio.",
      p2: "Los últimos años he trabajado en una empresa inmobiliaria, entre otras cosas responsable de la gestión de viviendas.",
      p3: "Como nosotros mismos compramos una propiedad en Torrevieja hace 5 años, sé lo importante que es tener a alguien de confianza que se ocupe rápido y con seriedad durante tu ausencia o alquiler.",
      pill_1: "Maestro instalador",
      pill_2: "Experiencia gestión inmobiliaria",
      pill_3: "Propietario en Torrevieja",
    },
    contact: {
      eyebrow: "Contacto",
      title: "Cuéntame qué necesitas.",
      subtitle:
        "Describe brevemente tu consulta — recibirás una valoración honesta en breve.",
      name: "Nombre",
      name_ph: "Nombre y apellido",
      email: "Correo electrónico",
      email_ph: "tu@email.com",
      service: "Servicio deseado",
      service_ph: "Elige un servicio",
      location: "Ubicación aproximada",
      location_ph: "Selecciona",
      message: "Descripción breve (opcional)",
      message_ph: "¿Qué hay que hacer?",
      submit: "Enviar consulta",
      submitting: "Enviando…",
      success_title: "Consulta enviada",
      success_desc: "Me pondré en contacto contigo pronto.",
      error_title: "Algo salió mal",
      error_desc: "Por favor, inténtalo más tarde.",
      required: "Obligatorio",
      invalid_email: "Introduce un email válido.",
      other_location: "Otra (bajo petición)",
    },
    footer: {
      tagline: "Multiservicio en la Costa Blanca sur — revisiones, servicio de llaves y más.",
      areas: "Zona de servicio",
      contact: "Contacto",
      rights: "Todos los derechos reservados.",
    },
  },
};

export const LANG_LABELS = {
  de: "DE",
  en: "EN",
  es: "ES",
};

export const LANG_FULL = {
  de: "Deutsch",
  en: "English",
  es: "Español",
};
